define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

    const configurationEditorRoles = ['Configuration Editor'];

    const collectionAdminRoles = ['Collection Administrator'];
    const colorAdminRoles = ['Color Administrator'];
    const colorAllocationAdminRole = ['Color Allocation Administrator'];
    const colorEditorRoles = colorAdminRoles.concat(['Color Editor']);

    const colorRuleAdministrator = ["Color Rule Administrator"];

    const colorPaletteAdministrator = ['Color Palette Administrator'];
    const colorPaletteEditor = colorPaletteAdministrator.concat(['Color Palette Editor']);

    const ecEditorRoles = ["Engineering Change Editor"];
    const ecAdminRoles = ["Engineering Change Administrator"];

    const hierarchyAdminRoles = ['Hierarchy Administrator'];
    const hierarchyLibAdminRoles = ['Hierarchy Library Administrator'];

    const materialAdminRoles = ['Material Administrator'];

	const merchProductVersionParticipant = ['Merch Product Version Participant']

    const issueAdminRoles = ['Issue Administrator'];
    const issueEditRoles = issueAdminRoles.concat(["Issue Editor"]);

    const productSpecAdminRoles = ['Product Specification Administrator'];
    const productSpecEditorRoles = ['Product Specification Editor'];
    const productSampleAdminRoles = ['Sample Administrator'];
    const productSpecLibAdminRoles = ['Product Specification Library Administrator'];

    const quoteSupplierAdminRoles = ['Quote Supplier Admin'];

    const sampleStorageAdminRoles = ['Sample Storage Administrator'];

    const securityGroupAdminRoles = ['Security Group Administrator'];

    const skuAdminRoles = ['SKU Administrator'];
	const sourcingAdminRoles = ['Sourcing Admin'];
	const sourcingEditRoles = sourcingAdminRoles.concat(['Sourcing Editor']);
    const styleAdminRoles = ['Style Administrator'];
    const styleEditRoles = styleAdminRoles.concat( ['Style Editor'] );
    const selectSetAdminRoles = ['Select Set Admin'];

    const supplierAdminRoles = ['Supplier Administrator'];
    const supplierEditRoles = supplierAdminRoles.concat(['Supplier Editor']);

    const tdsBOMCreatorRoles = ['TDS - BOM Creator','TDS - BOM Administrator'];
    const tdsBOMEditorRoles = ['TDS - BOM Editor'];

    const tdsSpecCreatorRoles = ['TDS - Spec Creator', 'TDS - Spec Administrator'];

    const tdsStyleReviewCreatorRoles = ['TDS - Style Review Creator','TDS - Style Review Administrator'];

    const tdsRoutingRoles = ['TDS - Routing Administrator', 'TDS - Routing Creator', 'Sourcing Library Administrator'];

    const testRunAdminRoles = ['Test Run Administrator'];

    const themeAdminRoles = ["Theme Administrator"];
    const themeEditRoles = ['Theme Administrator','Theme Editor'];
    const themeViewRoles = themeEditRoles.concat(['Theme Viewer']);

    const salesOrderAdminRoles = ['Sales Order Administrator'];
    const salesOrderEditRoles = salesOrderAdminRoles.concat(['Sales Order Editor']);

    const salesOrderGroupAdminRoles = ['Sales Order Group Administrator'];
    const salesOrderGroupEditRoles = salesOrderAdminRoles.concat(['Sales Order Group Editor']);

    const shapeAdminRoles = ["Shape Administrator"];
    const shapeEditRoles = shapeAdminRoles.concat(["Shape Editor"]);
    const shapeViewRoles = shapeEditRoles.concat(["Shape Viewer"]);

    const priceListAdminRoles = ["Price List Administrator", "Price List Config Administrator"];
    const priceListCreatorRoles = ["Price List Creator"];

    const threeDLibraryAdminRoles = ["3D Library Administrator"];

    csiAccess.addViewRoles({
        "_CS_ApparelViews":{
            "AllMaterials": {
                "NewMaterial":access(full(materialAdminRoles)),
                "Copy":access(full(materialAdminRoles))
            },
            "AllSamples": {
                "Copy":access(full(productSampleAdminRoles), full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            },
            "AllStyles": {
                "Copy":access(full(styleAdminRoles)),
                "Edit":access(full(styleEditRoles)),
                "MoveFromStyle":access(full(styleAdminRoles)),
                "NewFromStyle":access(full(styleAdminRoles)),
                "NewStyle":access(full(styleAdminRoles))
            },
            "StyleCards": {
                "NewStyle":access(full(styleAdminRoles))
            },
            "Classifiers": {
                "NewClassifier0":access(full(hierarchyAdminRoles)),
                "NewClassifier1":access(full(hierarchyAdminRoles)),
                "NewClassifier2":access(full(hierarchyAdminRoles)),
                "NewClassifier3":access(full(hierarchyAdminRoles)),
                "Copy":access(full(hierarchyAdminRoles))
            },
            "ColorSpecifications": {
                "NewColorSpecification":access(full(colorAdminRoles)),
                "NewFromColorSpecification":access(full(colorAdminRoles)),
                "Copy":access(full(colorAdminRoles)),
                "ReplaceColorSpecifications":access(full(colorAdminRoles))
            },
            "ColoredMaterials":{
                "Copy":access(full(materialAdminRoles))
            },
            "ColorPalettes": {
            	"NewColorPalette":access(full(colorPaletteAdministrator)),
            	"Edit":access(full(colorPaletteEditor),full(colorPaletteAdministrator)),
            	"Delete":access(full(colorPaletteAdministrator))
            },
            "MaterialSamples": {
                "NewMaterialSample":access(full(productSampleAdminRoles)),
                "DetachFromMaterial":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            },
            "MaterialSecurityGroups": {
                "NewMaterialSecurityGroup":access(full(securityGroupAdminRoles)),
                "Copy":access(full(securityGroupAdminRoles)),
                "Delete":access(full(securityGroupAdminRoles))
            },
            "PrintDesigns": {
                "Copy":access(full(colorAdminRoles)),
                "NewPrintDesign":access(full(colorAdminRoles))
            },
            "PrintSpecification": {
                "AggregateFromColorSpecifications":access(full(colorAdminRoles)),
                "NewColorSpecification":access(full(colorAdminRoles))
            },
            "PrintSpecifications":{
                "NewPrintSpecification":access(full(colorAdminRoles))
            },
            "ProductSymbols":{
                "NewProductSymbol":access(full(productSpecLibAdminRoles)),
                "Copy":access(full(productSpecLibAdminRoles))
            },
            "SampleStorages":{
                "NewSampleStorage":access(full(sampleStorageAdminRoles))
            },
            "SalesOrderGroups":{
                "NewSalesOrderGroup":access(full(salesOrderGroupEditRoles)),
                "Delete":access(full(salesOrderGroupEditRoles))
            },
            "Seasons":{
                "NewSeason":access(full(hierarchyAdminRoles))
            },
            "StructItemNameCodes":{
                "NewStructItemNameCode":access(full(configurationEditorRoles),full(productSpecLibAdminRoles)),
                "Copy":access(full(configurationEditorRoles),full(productSpecLibAdminRoles))
            },
            "Sizes":{
                "NewProductSize":access(full(productSpecLibAdminRoles))
            },
            "SizeRanges":{
                "NewSizeRange":access(full(productSpecLibAdminRoles)),
                "Copy":access(full(productSpecLibAdminRoles))
            },
            "Shapes":{ // TA27285 	implement "New Shape" action in Season view of Shapes
                "Copy":access(full(shapeEditRoles)),
                "NewShape":access(full(shapeEditRoles)),
                "CopyShapeMaster":access(full(shapeEditRoles)),
                "NewShapeFromStyle": access(full(shapeEditRoles))
            },
            "ShapeMasters": {
                "NewShapeMaster":access(full(shapeEditRoles)),
                "Copy":access(full(shapeEditRoles))
            },
            "ShapeSecurityGroups": {
                "NewShapeSecurityGroup":access(full(securityGroupAdminRoles)),
                "Copy":access(full(securityGroupAdminRoles))
            },
            "ShapeSamples":{
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            },
            "StyleTemplates":{
                "NewStyleTemplate" : access(full(styleAdminRoles)),
                "Copy" : access(full(styleAdminRoles))
            },
            "Themes":{
                "Copy":access(full(themeAdminRoles)),
                "CopyThemeMaster":access(full(themeAdminRoles)),
                "Edit":access(full(themeEditRoles)),
                "NewTheme":access(full(themeAdminRoles)),
                "NewThemeFromColorMaterials":access(full(themeAdminRoles)),
                "NewThemeFromColorways":access(full(themeAdminRoles)),
                "NewThemeFromStyle":access(full(themeAdminRoles)),
                "PromoteToTheme":access(full(themeAdminRoles))
            },
            "ThemeMasters":{
                "NewThemeMaster":access(full(themeAdminRoles)),
                "Copy":access(full(themeAdminRoles)),
                "Edit":access(full(themeEditRoles))
            },
            "ThemeSecurityGroups":{
                "NewThemeSecurityGroup":access(full(securityGroupAdminRoles)),
                "Copy":access(full(securityGroupAdminRoles))
            },
            "ThreeDEnvironments": {
	            "New3DEnvironment":access(full(threeDLibraryAdminRoles)),
				"Copy":access(full(threeDLibraryAdminRoles)),
				"Delete":access(full(threeDLibraryAdminRoles))
            },
            "CameraPositions": {
                "NewCameraPosition":access(full(threeDLibraryAdminRoles)),
                "Copy":access(full(threeDLibraryAdminRoles)),
            },
            "StyleSnapshotTemplates":{
                "NewStyleSnapshotTemplate":access(full(threeDLibraryAdminRoles)),
                "Copy":access(full(threeDLibraryAdminRoles)),
            },
            "MaterialSnapshotTemplates":{
                "NewMaterialSnapshotTemplate":access(full(threeDLibraryAdminRoles)),
                "Copy":access(full(threeDLibraryAdminRoles)),
            },
            "CompetitiveStyles":{
                "NewCompetitiveStyle":access(full(productSpecLibAdminRoles)),
                "CopyCompetitiveStyle":access(full(productSpecLibAdminRoles)),
                "DeleteCompetitiveStyle":access(full(productSpecLibAdminRoles)),
                "EditCompetitiveStyle":access(full(productSpecLibAdminRoles))
            }
        },
        "StructureItem":{
			"__Print__":{
				"NewStyleForm":access(full(styleAdminRoles)),
				"NewStyleWizard":access(full(styleAdminRoles))
			},
            "AllSamples":{
                "Copy":access(full(productSampleAdminRoles), full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles)),
                "Delete":access(full(productSampleAdminRoles)),
                "NewStyle":access(full(styleAdminRoles))
            },
            "AllSKUs":{
                "MassCreateSKUs":access(full(skuAdminRoles))
            },
            "AllStyles":{
                "Copy":access(full(styleAdminRoles)),
                "Edit":access(full(styleEditRoles)),
                "MoveStyleForm":access(full(styleAdminRoles)),
                "MoveStyleWizard":access(full(styleAdminRoles)),
                "NewFromStyleForm":access(full(styleAdminRoles)),
                "NewFromStyleWizard":access(full(styleAdminRoles)),
                "NewStyleForm":access(full(styleAdminRoles)),
                "NewStyleWizard":access(full(styleAdminRoles))
            },
            "Defaults":{
				"ManageDefaults":access(full(hierarchyLibAdminRoles)),
                "ManageDefaults_TG":access(full(hierarchyLibAdminRoles))
            },
            "StructureItemIssues": {
                "NewIssue":access(full(issueEditRoles)),
                "Edit":access(full(issueEditRoles)),
                "Copy":access(full(issueAdminRoles)),
                "Delete":access(full(issueAdminRoles))
            }
        },
        "Season":{
            "Category1s":{
                "Copy":access(full(hierarchyAdminRoles)),
                "NewCategory1":access(full(hierarchyAdminRoles)),
                "NewFromCategory1":access(full(hierarchyAdminRoles)),
                "NewWithMultTemplates":access(full(hierarchyAdminRoles)),
                "NewWithOneTemplate":access(full(hierarchyAdminRoles)),
                "NewWithZeroTemplates":access(full(hierarchyAdminRoles))
            },
            "Shapes":{
                "AggregateShape":access(full(shapeEditRoles)),
                "NewFromShape":access(full(shapeEditRoles)),
                "NewShape":access(full(shapeEditRoles))

            },
            "Themes":{
                "AggregateTheme":access(full(themeEditRoles)),
                "GenerateColorMatchingRules":access(full(colorRuleAdministrator)),
                "MassCreateStyleBOMs":access(full(tdsBOMCreatorRoles), full(tdsBOMEditorRoles), full(productSpecAdminRoles), full(productSpecEditorRoles)),
                "MassCreateUpdate":access(full(tdsBOMCreatorRoles), full(tdsBOMEditorRoles), full(productSpecAdminRoles), full(productSpecEditorRoles)),
                "MassUpdate":access(full(tdsBOMCreatorRoles), full(tdsBOMEditorRoles), full(productSpecAdminRoles), full(productSpecEditorRoles)),
                "NewFromTheme":access(full(themeEditRoles)),
                "NewTheme":access(full(themeEditRoles)),
                "SeasonReportExceptions":access(full(themeViewRoles))
            },
            "MerchProducts":{
                "NewStyleCandidate": access( full(merchProductVersionParticipant)),
                "SelectStyleCandidates": access( full(merchProductVersionParticipant))
            }
        },
        "Category1":{
            "Category2s":{
                "Copy":access(full(hierarchyAdminRoles)),
                "NewCategory2":access(full(hierarchyAdminRoles)),
                "NewFromCategory2":access(full(hierarchyAdminRoles)),
                "NewWithMultTemplates":access(full(hierarchyAdminRoles)),
                "NewWithOneTemplate":access(full(hierarchyAdminRoles)),
                "NewWithZeroTemplates":access(full(hierarchyAdminRoles))
            }
        },
        "Category2":{
            "Collections":{
                "Copy":access(full(collectionAdminRoles), full(styleAdminRoles)),
                "NewCollection":access(full(collectionAdminRoles)),
                "NewFromCollection":access(full(collectionAdminRoles), full(styleAdminRoles)),
                "NewWithMultTemplates":access(full(collectionAdminRoles), full(styleAdminRoles)),
                "NewWithOneTemplate":access(full(collectionAdminRoles), full(styleAdminRoles)),
                "NewWithZeroTemplates":access(full(collectionAdminRoles), full(styleAdminRoles))
            }
        },
        "Collection":{
            "Styles":{
                "Copy":access(full(styleAdminRoles)),
                "MoveFrom":access(full(styleAdminRoles)),
                "NewFromStyle":access(full(styleAdminRoles)),
                "NewStyle":access(full(styleAdminRoles))
            }
        },
        "ColorMaterial":{
            "ProductSamples": {
                "NewMaterialSample":access( full(productSampleAdminRoles)),
                "AttachMaterialSample":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "DetachFromMaterial":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            }
        },
        "ColorPalette":{
            "ColorsInPalette":{
            	"NewColorInPalette":access(full(colorPaletteEditor)),
            	"NewFromColorSpecification":access(full(colorPaletteEditor)),
            	"MassColorAllocation":access(full(colorAllocationAdminRole)),
            	"MergeColorsInPalette":access(full(colorAllocationAdminRole)),
            	"LinkActual":access(full(colorPaletteEditor)),
            	"PromoteSpecialToColorSpec":access(full(colorPaletteEditor)),
            	"ReplaceColorSpecification":access(full(colorPaletteEditor))
			},
			"ColorPaletteCard":{
				"MassColorAllocation":access(full(colorAllocationAdminRole))
			}
        },
        "IssueLog":{
            "Issues":{
                "AddToEC":access(full(ecEditorRoles), full(ecAdminRoles)),
                "Copy":access(full(issueEditRoles)),
                "Delete":access(full(issueAdminRoles)),
                "Edit":access(full(issueEditRoles)),
                "New":access(full(issueEditRoles))
            }
        },
        "Material":{
            "DataSheetIndex": {
                "NewFromOriginalProduct": access(full(productSpecAdminRoles), full(tdsBOMCreatorRoles), full(tdsSpecCreatorRoles), full(tdsRoutingRoles), full(testRunAdminRoles))
            },
            "ProductSamples": {
                "NewMaterialSample":access(full(productSampleAdminRoles)),
                "NewMaterialBOM":access(full(tdsBOMCreatorRoles)),
                "AttachMaterialSample":access(full(productSampleAdminRoles)),
                "DetachFromMaterial":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            },
            "SelectSets":{
                "NewSelectSet":access(full(selectSetAdminRoles)),
                "NewSKUMaterialSelectSet":access(full(selectSetAdminRoles))
            },
            "ProductColors":{
                "AddToEC":access(full(ecEditorRoles), full(ecAdminRoles)),
                "EnableColorMaterialAllocation":access(full(sourcingEditRoles)),
                "ManageColorMaterialAllocation":access(full(sourcingEditRoles))
            },
            "ProductSKU":{
                "AddToEC":access(full(ecEditorRoles), full(ecAdminRoles))
            }
        },
        "MaterialSecurityGroup":{
            "MaterialSamples":{
                "DetachFromMaterial":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "NewMaterialSample":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            },
            "SecurityGroupMaterials":{
                "AggregateMaterials":access(full(materialAdminRoles)),
                "NewMaterial":access(full(materialAdminRoles))
            }
        },
        "PrintDesignRevision":{
            "Positions": {
                "Copy":access(full(colorAdminRoles))
            },
        "RevisionColors": {
            "Copy":access(full(colorAdminRoles))
            }
        },
        "ProductSource":{
            "StyleSamples":{
                "NewStyle":access(full(styleAdminRoles)),
                "NewApparelBOM":access(full(tdsBOMCreatorRoles)),
                "NewReviewStyle":access(full(tdsStyleReviewCreatorRoles))
            },
            "MaterialSamples": {
                "NewMaterialSample":access(full(productSampleAdminRoles)),
                "NewMaterialBOM":access(full(tdsBOMCreatorRoles)),
                "AttachMaterialSample":access(full(productSampleAdminRoles)),
                "DetachFromMaterial":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            }
        },
        "SampleStorage":{
            "MaterialSamples": {
                "NewMaterialSample":access(full(productSampleAdminRoles)),
                "AttachMaterialSample":access(full(productSampleAdminRoles)),
                "DetachFromMaterial":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            }
        },
        "Shape":{
            "ShapeSamples":{
                "NewSample":access(full(productSampleAdminRoles)),
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            },
            "ShapeStyles":{
                "CreateStyle":access(full(styleAdminRoles)),
                "MassUpdateStyleAttributes":access(full(shapeViewRoles))
            }
        },
        "ShapeSecurityGroup":{
            "ShapeSamples":{
                "Copy":access(full(productSampleAdminRoles)),
                "Delete":access(full(productSampleAdminRoles))
            }
        },
        "Style":{
            "CompetitiveStyles":{
                "NewCompetitiveStyle":access(full(productSpecLibAdminRoles)),
                "CopyCompetitiveStyle":access(full(productSpecLibAdminRoles)),
                "EditCompetitiveStyle":access(full(productSpecLibAdminRoles))
            },
            "PriceList":{
                "NewPriceList":access(full(priceListAdminRoles), full(priceListCreatorRoles)),
                "NewFromPriceList":access(full(priceListAdminRoles), full(priceListCreatorRoles)),
                "Delete":access(full(priceListAdminRoles))
            },
            "ProductAlternatives":{
                "Copy":access(full(productSpecAdminRoles)),
                "Delete":access(full(productSpecAdminRoles)),
                "NewProductAlternative":access(full(productSpecAdminRoles))
            },
            "ProductColors":{
                "AddToEC":access(full(ecEditorRoles), full(ecAdminRoles)),
                "AddColorwayToTheme":access(full(themeEditRoles)),
                "AggregateFromProductColors":access(full(styleEditRoles)),
                "Copy":access(full(styleEditRoles)),
                "NewColorway":access(full(styleEditRoles)),
                "PushColorwaysToStyles": access(full(styleEditRoles)),
            },
            "ProductSalesRegions":{
                "AggregateFromProductSalesRegions":access(full(productSpecAdminRoles)),
                "Delete":access(full(productSpecAdminRoles))
            },
            "ProductSamples":{
                "Copy":access(full(productSampleAdminRoles), full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles)),
                "Delete":access(full(productSampleAdminRoles)),
                "NewApparelBOM":access(full(tdsBOMCreatorRoles)),
                "NewReviewStyle":access(full(tdsStyleReviewCreatorRoles)),
                "NewSample":access(full(productSampleAdminRoles)),
                "NewStyle":access(full(styleAdminRoles))
            },
            "ProductSKU":{
                "AddToEC":access(full(ecEditorRoles), full(ecAdminRoles)),
                "Copy":access(full(skuAdminRoles)),
                "NewSKU":access(full(skuAdminRoles))
            },
            "Properties":{
                "MoveTo":access(full(styleAdminRoles))
            },
            "SelectSets":{
                "NewSelectSet":access(full(selectSetAdminRoles)),
                "NewColorwaySelectSet":access(full(selectSetAdminRoles)),
                "NewSKUSelectSet":access(full(selectSetAdminRoles)),
                "Copy":access(full(selectSetAdminRoles))
            }
        },
        "SalesOrder":{
            "Properties":{
                "Freeze":access(full(salesOrderEditRoles))
            },
            "LineItems":{
                "NewLineItem":access(full(salesOrderEditRoles)),
                "Delete":access(full(salesOrderEditRoles))
            }
        },
        "Theme":{
            "BOMs": {
                "Copy":access(full(tdsBOMCreatorRoles),full(productSpecAdminRoles)),
                "CreateLinkedStyleBOMs":access(full(tdsBOMCreatorRoles),full(productSpecAdminRoles)),
                "MassUpdateStyleBOMs":access(full(tdsBOMCreatorRoles), full(tdsBOMEditorRoles), full(productSpecAdminRoles), full(productSpecEditorRoles)),
                "NewFromBOMTemplate":access(full(tdsBOMCreatorRoles),full(productSpecAdminRoles)),
                "NewThemeBOM":access(full(tdsBOMCreatorRoles),full(productSpecAdminRoles)),
            },
            "ThemeStyles":{
                "CreateStyle":access(full(styleAdminRoles))
            }
        },
    });
});